import React, { useState } from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useSigninModal } from "../../context/SigninModalContext";
import "./HowItWorks.scss";

const steps = [
  {
    n: "1",
    title: "Save from anywhere",
    body: "Browsing Amazon, a boutique, or Safari? Drop it into OllaCart with the extension or iOS app. One place for every find.",
    cue: "Extension · iOS",
  },
  {
    n: "2",
    title: "Ask your people",
    body: "Share the cart when you want opinions. Follow friends who share theirs. Skip the lonely should-I spiral.",
    cue: "Share · Follow",
  },
  {
    n: "3",
    title: "Buy without the restart",
    body: "When you are ready, check out with affiliate or direct purchase. The trail of what you liked is still right there.",
    cue: "Affiliate · Direct",
  },
];

const HowItWorks = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });
  const { openSignin } = useSigninModal();
  const [active, setActive] = useState(0);

  return (
    <motion.section
      id="how-it-works"
      className="how-it-works"
      ref={ref}
      initial={{ opacity: 0, y: 28 }}
      animate={{ opacity: inView ? 1 : 0, y: inView ? 0 : 28 }}
      transition={{ duration: 0.55, ease: "easeOut" }}
    >
      <div id="feature-container" className="how-it-works__anchor" aria-hidden="true" />

      <div className="how-it-works__inner">
        <header className="how-it-works__header">
          <div>
            <p className="how-it-works__eyebrow">How it works</p>
            <h2 className="how-it-works__title">
              Find it. Talk it out.
              <br />
              Own it.
            </h2>
          </div>
          <p className="how-it-works__lead">
            Three moves, one cart. Less tab chaos, more confidence before you pay.
          </p>
        </header>

        <div className="how-it-works__rail" role="list">
          <div className="how-it-works__spine" aria-hidden="true" />
          {steps.map((step, i) => (
            <motion.button
              type="button"
              key={step.n}
              role="listitem"
              className={
                "how-it-works__step" +
                (active === i ? " how-it-works__step--active" : "")
              }
              onMouseEnter={() => setActive(i)}
              onFocus={() => setActive(i)}
              onClick={() => setActive(i)}
              initial={{ opacity: 0, y: 18 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.45, delay: 0.1 + i * 0.1 }}
            >
              <span className="how-it-works__node" aria-hidden="true">
                {step.n}
              </span>
              <div className="how-it-works__copy">
                <span className="how-it-works__cue">{step.cue}</span>
                <h3>{step.title}</h3>
                <p>{step.body}</p>
              </div>
            </motion.button>
          ))}
        </div>

        <div className="how-it-works__actions">
          <button
            type="button"
            className="how-it-works__btn how-it-works__btn--primary"
            onClick={openSignin}
          >
            Start free
          </button>
          <a className="how-it-works__link" href="#review-container">
            Hear from shoppers
          </a>
        </div>
      </div>
    </motion.section>
  );
};

export default HowItWorks;
